import { useSPAContext } from "@/providers/spa-provider";
import { RouteNames } from "@/types/route-names";
import { CountryFlag } from "@/components/ui/country-flag/country-flag";
import { useUser } from "@/providers/user-provider";
import { RewardsInfoDialog } from "@/components/ui/dialog/rewards-info-dialog";
import { useState } from "react";
import { MAX_DAILY_REWARDED_DUELS } from "types/duels/types";

export const HomeHeader = () => {
  const { setViewedPlayerId, setCurrentRoute } = useSPAContext();
  const { playerCountry, username, pokeCoins, pokeShards, rewardedDuelsToday } =
    useUser();
  const [isRewardsDialogOpen, setIsRewardsDialogOpen] = useState(false);

  const matchesRemaining = Math.max(
    0,
    MAX_DAILY_REWARDED_DUELS - (rewardedDuelsToday || 0),
  );

  return (
    <header className="w-full flex items-center justify-between gap-2 p-1 xs:p-2 bg-gradient-to-b from-black/90 via-black/50 to-transparent z-100 relative">
      {/* User Info */}
      <div
        className="flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity active:scale-95"
        onClick={() => {
          setViewedPlayerId(undefined);
          setCurrentRoute(RouteNames.PLAYER_PROFILE);
        }}
      >
        <div className="scale-75 xs:scale-100">
          <CountryFlag countryCode={playerCountry} size="md" />
        </div>
        <span className="text-pk-gray-5 text-xl xs:text-2xl text-shadow font-bold tracking-wide drop-shadow-lg">
          {username || "PLAYER"}
        </span>
      </div>

      {/* Currency & Limits */}
      <div className="flex items-center gap-1.5">
        <div
          className="flex items-center gap-1.5 h-8 xs:h-9 bg-pk-gray-1/90 border-2 border-pk-yellow-3 rounded-lg px-2 shadow-md"
          title="Pokecoins"
        >
          <img
            src="/assets/app-ui/poke-coin.png"
            alt="Coins"
            className="w-auto h-5 xs:h-6"
          />
          <span className="text-pk-yellow-3 font-bold text-sm">
            {pokeCoins ?? "..."}
          </span>
        </div>

        <div
          className="relative flex items-center gap-1.5 h-8 xs:h-9 bg-pk-gray-1/90 border-2 border-pk-blue-5 rounded-lg px-2 shadow-md"
          title="Pokeshards"
        >
          <img
            src="/assets/app-ui/poke-shard.png"
            alt="Shards"
            className="w-auto h-5 xs:h-6"
          />
          <span className="text-pk-blue-5 font-bold text-sm">
            {pokeShards ?? "..."}
          </span>
        </div>

        <button
          onClick={() => setIsRewardsDialogOpen(true)}
          className="flex items-center gap-1.5 h-8 xs:h-9 bg-pk-gray-1/90 border-2 border-pk-gray-3 rounded-lg px-2 shadow-md hover:bg-pk-gray-1 transition-colors cursor-pointer active:scale-95"
          title="Daily duel rewards"
        >
          <span className="text-sm">🎁</span>
          <span
            className={`font-bold text-sm ${
              matchesRemaining > 0 ? "text-pk-green-5" : "text-pk-red-5"
            }`}
          >
            {matchesRemaining}/{MAX_DAILY_REWARDED_DUELS}
          </span>
        </button>

        <button
          onClick={() => setCurrentRoute(RouteNames.FRIENDS)}
          className="flex items-center gap-1.5 h-8 xs:h-9 bg-pk-gray-1/90 border-2 border-pk-gray-3 rounded-lg px-2 shadow-md hover:bg-pk-gray-1 transition-colors cursor-pointer active:scale-95"
          title="Friends"
        >
          <span className="text-sm">👥</span>
        </button>
      </div>

      <RewardsInfoDialog
        isOpen={isRewardsDialogOpen}
        onClose={() => setIsRewardsDialogOpen(false)}
      />
    </header>
  );
};
